/**
 * Quantity Selector - +/- Button Functionality
 * Handles increment/decrement buttons for quantity inputs
 */

(function() {
    'use strict';

    function initQuantitySelectors() {
        const selectors = document.querySelectorAll('.quantity-selector');
        
        selectors.forEach(selector => {
            // Skip if already initialized
            if (selector.dataset.initialized === 'true') return;
            selector.dataset.initialized = 'true';
            
            const minusBtn = selector.querySelector('.quantity-selector__button--minus');
            const plusBtn = selector.querySelector('.quantity-selector__button--plus');
            const input = selector.querySelector('.quantity-input, input[is="quantity-input"]');
            
            if (!input) return;
            
            const min = parseInt(input.getAttribute('min')) || 1;
            const max = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : null;
            
            // Minus button click
            if (minusBtn) {
                minusBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    let currentValue = parseInt(input.value) || min;
                    if (currentValue > min) {
                        input.value = currentValue - 1;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                        updateButtonStates(selector, parseInt(input.value), min, max);
                    }
                });
            }
            
            // Plus button click
            if (plusBtn) {
                plusBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    let currentValue = parseInt(input.value) || min;
                    if (!max || currentValue < max) {
                        input.value = currentValue + 1;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                        updateButtonStates(selector, parseInt(input.value), min, max);
                    }
                });
            }
            
            // Input change handler
            input.addEventListener('change', function() {
                let value = parseInt(this.value) || min;
                
                // Clamp value between min and max
                if (value < min) value = min;
                if (max && value > max) value = max;
                
                this.value = value;
                updateButtonStates(selector, value, min, max);
            });
            
            // Initial button state
            updateButtonStates(selector, parseInt(input.value) || min, min, max);
        });
    }

    function updateButtonStates(selector, value, min, max) {
        const minusBtn = selector.querySelector('.quantity-selector__button--minus');
        const plusBtn = selector.querySelector('.quantity-selector__button--plus');
        
        if (minusBtn) {
            minusBtn.disabled = value <= min;
        }
        
        if (plusBtn) {
            plusBtn.disabled = max !== null && value >= max;
        }
    }

    // Initialize on DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initQuantitySelectors);
    } else {
        initQuantitySelectors();
    }

    // Re-initialize on cart updates (for AJAX cart)
    document.addEventListener('cart:updated', function() {
        // Reset initialized state and re-init
        document.querySelectorAll('.quantity-selector').forEach(s => s.dataset.initialized = 'false');
        initQuantitySelectors();
    });

    // MutationObserver to detect dynamically added quantity selectors
    const observer = new MutationObserver(function(mutations) {
        let shouldInit = false;
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        if (node.classList && node.classList.contains('quantity-selector')) {
                            shouldInit = true;
                        } else if (node.querySelector && node.querySelector('.quantity-selector')) {
                            shouldInit = true;
                        }
                    }
                });
            }
        });
        if (shouldInit) {
            initQuantitySelectors();
        }
    });

    // Start observing the document body for DOM changes
    if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
    } else {
        document.addEventListener('DOMContentLoaded', function() {
            observer.observe(document.body, { childList: true, subtree: true });
        });
    }

    // Export for use in other scripts
    window.initQuantitySelectors = initQuantitySelectors;
})();
